module.exports = __webpack_public_path__ + "15ec67360d3c3d82c28aa21a6ae7116c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/detail-view.svg
// module id = 95
// module chunks = 0